import { graphql } from "../generated/gql";

export const GetCompany = graphql(`
  query GetCompany {
    getCompany {
      ID
      tags {
        color
        description
        id
        name
      }
    }
  }
`);
